<h1>Versión de Angular: {{ angularVersion }}</h1>
<h1 *ngIf="tiempoRestante > 0">Tiempo restante para desconexión: <span class="text-danger">{{ tiempoRestante | msToHms }}</span></h1>
<hr>

<div class="row">

    <div class="col">
        <h1 *ngIf="localTime">Hora en el equipo local: {{ localTime | date:'yyyy-MM-dd HH:mm:ss' }}</h1>
        <div *ngIf="serverTime?.data">
            <h1>Hora PHP: <span class="text-info">{{ serverTime.data.serverTimePHP }}</span> </h1>
            <h2>Zona horaria PHP: {{ serverTime.data.phpTimeZone }}</h2>
            <h1>Hora MySQL: <span class="text-info">{{ serverTime.data.serverTimeSQL }}</span></h1>
            <h2>Zona horaria MySQL global: {{ serverTime.data.sqlGlobalTimeZone }}</h2>
            <h2>Zona horaria MySQL sesión: {{ serverTime.data.sqlSessionTimeZone }}</h2>
        </div>
    </div>

    <div class="col">
        <h1>Información de environment:</h1>

        <h2><b>entorno:</b> {{ environment.entorno }}</h2>
        <hr>
        <h2><b>apiURL:</b> {{ environment.apiURL }}</h2>
        <h2><b>url_cliente:</b> {{ environment.url_cliente }}</h2>
        <hr>
        <h2><b>fotoDir:</b> {{ environment.fotoDir }}</h2>
        <h2><b>pdfDir:</b> {{ environment.pdfDir }}</h2>
        <h2><b>xlsDir:</b> {{ environment.xlsDir }}</h2>
        <hr>
        <h2><b>timeOut:</b> {{ environment.timeOut }} = {{ environment.timeOut | msToHms }} (hh:mm:ss)</h2>
        <h2><b>timeRefreshCampanyas:</b> {{ environment.timeRefreshCampanyas }} = {{ environment.timeRefreshCampanyas | msToHms }} (hh:mm:ss)</h2>
        <h2><b>timeRefreshPda:</b> {{ environment.timeRefreshPda }} = {{ environment.timeRefreshPda | msToHms }} (hh:mm:ss)</h2>
        <h2><b>timeAutoSave:</b> {{ environment.timeAutoSave }} = {{ environment.timeAutoSave | msToHms }} (hh:mm:ss)</h2>
        <hr>
        <h2><b>defaultTema:</b> {{ environment.defaultTema }}</h2>
        <h2><b>rolesAdministracion:</b> {{ environment.rolesAdministracion }}</h2>
    </div>

</div> <!-- Fin row -->
<hr>

<div *ngIf="loading">
    <div class="text-center">
        <div class="spinner-border"
             role="status">
            <span class="sr-only">Cagando...</span>
        </div>
    </div>
</div>

<div [innerHTML]="info"></div>